export { default } from "./ProductDetailView";
